// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';

// Internal dependencies
import MText from '../../../../../components/Common/MText';
import { IsEmpty } from '../../../../../common/util';

const useStyles = makeStyles({
  walletList: {
    maxHeight:    '320px',
    overflowY:    'auto',
    marginTop:    '1rem',
    paddingRight: '2px',
  },
  walletCard: {
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'space-between',
    padding:         '12px 16px',
    marginBottom:    '10px',
    borderRadius:    '8px',
    border:          '1px solid #EAEAEA',
    backgroundColor: '#FAFBFD',
    cursor:          'pointer',
    transition:      'all 0.2s ease-in-out',
    outline:         'none',

    '&:hover': {
      backgroundColor: '#FFFFFF',
      borderColor:     '#4A5568',
      boxShadow:       '0px 4px 12px rgba(0, 0, 0, 0.05)',
    },

    '&:focus-visible': {
      borderColor:     '#4A5568',
      backgroundColor: '#FFFFFF',
    },
  },
});

const LoyaltyCardList = (props) => {
  const { gift, handleLoyaltyCardClick } = props;

  const classes = useStyles();
  return (
    <div>
      <MText
        variant="subtitle1"
        bold
        className="mb-1"
        text="Linked Loyalty Cards"
      />

      {!IsEmpty(gift.loyaltyCards) ? (
        <div className={classes.walletList}>
          {gift.loyaltyCards.map((card) => (
            <div
              key={card.id}
              className={classes.walletCard}
              onClick={() => handleLoyaltyCardClick(card.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleLoyaltyCardClick(card.id);
                }
              }}
            >
              <div className="d-flex align-items-center">
                <div>
                  <MText
                    variant="subtitle2"
                    semibold
                    style={{ lineHeight: 1.2 }}
                    text={card.name || 'Loyalty Program'}
                  />
                </div>
              </div>

              <ArrowForward
                fontSize="small"
                style={{ color: '#718096' }}
              />
            </div>
          ))}
        </div>
      ) : (
        <MText
          variant="body2"
          colour="rgba(0, 0, 0, 0.54)"
          className="py-2"
          text="No linked loyalty card data found."
        />
      )}
    </div>
  );
};

LoyaltyCardList.propTypes = {
  gift: PropTypes.shape({
    label:           PropTypes.string,
    id:              PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pageId:          PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    type:            PropTypes.string,
    startDate:       PropTypes.oneOfType([PropTypes.string, PropTypes.shape(Object)]),
    endDate:         PropTypes.oneOfType([PropTypes.string, PropTypes.shape(Object)]),
    extendedEndDate: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(Object)]),
    status:          PropTypes.string,
    terms:           PropTypes.string,
    images:          PropTypes.arrayOf(PropTypes.shape(Object)),
    pauseIssuance:   PropTypes.bool,
    loyaltyCards:    PropTypes.arrayOf(
      PropTypes.shape({
        id:   PropTypes.number,
        name: PropTypes.string,
      }),
    ),
  }).isRequired,
  handleLoyaltyCardClick: PropTypes.func.isRequired,
};

export default LoyaltyCardList;
